import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';
export function NotFound() {
  const {
    pathname
  } = useLocation();
  useSeo({
    title: 'Pagina niet gevonden | AMIRA Beauty',
    description: 'Deze pagina bestaat niet.',
    path: pathname,
    noindex: true
  });
  return <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-32 text-center" data-id="element-674" data-mp="1557przif2mox">
      <h1 className="font-display text-4xl uppercase tracking-display" data-id="element-675" data-mp="1a4kdemh43xsk">Deze pagina bestaat niet</h1>
      <p className="mt-3 text-muted" data-id="element-676" data-mp="1f2ls6v7i9ay8">Misschien is het product verplaatst. Bekijk onze bestsellers.</p>
      <Link to="/collectie/bestsellers" className="mt-8 inline-flex h-12 items-center rounded-full bg-ink px-6 text-sm font-medium text-canvas hover:bg-berry" data-id="element-677" data-mp="1jtlr2606q33d">
        Naar bestsellers
      </Link>
    </div>;
}